<template>
  <div class="warn-manage-page">
    <management-table
      title="告警管理"
      eyebrow="Alarm Manage"
      :data="pageWarnList"
      :loading="loading"
      :current-page="pageInfo.pageNum"
      :page-size="pageInfo.pageSize"
      :total="pageInfo.total"
      empty-text="暂无告警数据"
      @current-change="handlePageChange"
    >
      <template slot="filters">
        <div class="search-item warn-device-filter">
          <label class="search-label">设备名称:</label>
          <el-input
            v-model="deviceName"
            placeholder="请输入设备名称"
            clearable
            class="search-input"
          />
        </div>
        <div class="search-item warn-status-filter">
          <label class="search-label">处理状态:</label>
          <el-select
            v-model="filterStatus"
            placeholder="请选择处理状态"
            clearable
            class="search-select"
          >
            <el-option label="全部" value="" />
            <el-option label="未处理" value="1" />
            <el-option label="已处理" value="2,4" />
          </el-select>
        </div>
      </template>

      <template slot="actions">
        <el-button type="primary" icon="el-icon-search" class="search-btn" @click="handleSearch">查询</el-button>
      </template>

      <template slot="columns">
        <el-table-column prop="powerStationName" label="设备名称" align="center" width="220" show-overflow-tooltip />
        <el-table-column prop="warnText" label="告警信息" align="center" min-width="320" show-overflow-tooltip />
        <el-table-column prop="create_time" label="告警时间" align="center" width="200" show-overflow-tooltip />
        <el-table-column prop="optStatus" label="处理状态" align="center" width="130">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.optStatus === 1" type="danger" size="small" class="tag-unhandled">未处理</el-tag>
            <el-tag v-else-if="scope.row.optStatus === 2" type="info" size="small" class="tag-closed">已关闭</el-tag>
            <el-tag v-else-if="scope.row.optStatus === 3" type="warning" size="small" class="tag-processing">处理中</el-tag>
            <el-tag v-else-if="scope.row.optStatus === 4" type="success" size="small" class="tag-finished">已完结</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <span
              v-if="canEdit === 1 && (scope.row.optStatus === 1 || scope.row.optStatus === 3)"
              class="process-btn"
              @click="handleProcess(scope.row)"
            >处理</span>
            <span
              v-else-if="scope.row.optStatus === 1 || scope.row.optStatus === 3"
              class="processed-text"
            >只读</span>
            <span v-else class="processed-text">已处理</span>
          </template>
        </el-table-column>
      </template>
    </management-table>

    <!-- 告警处理弹窗 -->
    <el-dialog 
      title="处理告警" 
      :visible.sync="showProcessDialog"
      width="400px"
      :close-on-click-modal="false"
      custom-class="warn-process-dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <el-form
        :model="processForm"
        label-width="80px"
        class="blue-form"
      >
        <el-form-item label="处理状态" required>
        <el-select
            v-model="processForm.optStatus"
            class="dialog-select"
        >
            <el-option label="未处理" value="1" />
            <el-option label="已处理" value="2" />
        </el-select>
        </el-form-item>
        <el-form-item label="处理备注">
          <el-input
            type="textarea"
            v-model="processForm.remark"
            rows="3"
            class="dialog-textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="showProcessDialog = false">取消</el-button>
        <el-button type="primary" class="save-btn" @click="submitProcess">确认处理</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ManagementTable from '../../components/ManagementTable.vue'
import { getAccountPermission } from '../../utils/accountPermission'

export default {
  name: 'warnListVue',
  components: {
    ManagementTable
  },
  data() {
    return {
      loading: false,
      canEdit: 1,
      warnList: [],
      showProcessDialog: false,
      currentWarn: {},
      processForm: {
        remark: '',
        optStatus: '1'
      },
      filterStatus: '',
      deviceName: '',
      appliedFilters: {
        filterStatus: '',
        deviceName: ''
      },
      // 分页参数
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    pageWarnList() {
      return this.warnList
    }
  },
  mounted() {
    this.canEdit = getAccountPermission()
    this.loadWarnList()
  },
  methods: {
    // 加载告警列表
    loadWarnList() {
      this.loading = true
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        deviceName: this.appliedFilters.deviceName,
        dealStatuses: this.appliedFilters.filterStatus
          ? this.appliedFilters.filterStatus.split(',').map(Number)
          : []
      }
      this.$request.post('/api/index/power/warn/data', params).then(response => {
        if (response.data.result) {
          const pageData = response.data.data || {}
          this.warnList = pageData.list || []
          this.pageInfo.total = pageData.totalCount || 0
        } else {
          this.$message.error('告警列表加载失败：' + response.data.message)
          this.warnList = []
          this.pageInfo.total = 0
        }
      }).catch(err => {
        this.$message.error('网络异常，无法加载告警列表')
        this.warnList = []
        this.pageInfo.total = 0
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    // 仅在用户点击查询时应用新筛选条件
    handleSearch() {
      this.appliedFilters = {
        filterStatus: this.filterStatus,
        deviceName: (this.deviceName || '').trim()
      }
      this.pageInfo.pageNum = 1
      this.loadWarnList()
    },
    // 服务端分页切换
    handlePageChange(val) {
      this.pageInfo.pageNum = val
      this.loadWarnList()
    },
    // 处理告警
    handleProcess(row) {
      this.currentWarn = row
      this.processForm.optStatus = row.optStatus + ''
      this.processForm.remark = ''
      this.showProcessDialog = true
    },
    // 提交处理结果
    submitProcess() {
      if (!this.processForm.optStatus) {
        this.$message.error('请选择处理状态')
        return
      }
      const params = {
        id: this.currentWarn.id,
        dealStatus: Number(this.processForm.optStatus)
      }
      this.$request.post('/api/index/set/alarm/status', params).then(response => {
        const res = response.data
        if (res.result) {
          this.$message.success(res.message || '告警处理成功')
          this.showProcessDialog = false
          this.loadWarnList()
          this.$emit('warnUpdated')
        } else {
          this.$message.error(res.message || '告警处理失败')
        }
      }).catch(err => {
        this.$message.error('网络异常，告警处理失败')
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
.warn-manage-page {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.warn-status-filter {
  flex-basis: 250px;
}

.warn-device-filter {
  flex-basis: 300px;
}

.process-btn,
.processed-text {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  height: 28px;
  padding: 0 12px;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.process-btn {
  border: 1px solid var(--solar-border-strong, #0099FF);
  color: var(--solar-primary, #0099FF);
  cursor: pointer;
  transition: color 0.3s, border-color 0.3s, background-color 0.3s;
}

.process-btn:hover {
  border-color: var(--solar-border-strong, #00CCFF);
  color: var(--solar-primary, #00CCFF);
  background-color: rgba(var(--solar-primary-rgb, 0, 153, 255), 0.12);
}

.processed-text {
  border: 1px solid rgba(135, 206, 250, 0.45);
  color: var(--solar-text, #87CEFA);
}

:deep(.tag-unhandled) {
  --el-tag-bg-color: var(--solar-danger, #FF4500);
  --el-tag-text-color: var(--solar-text-strong, #FFFFFF);
}

:deep(.tag-closed) {
  --el-tag-bg-color: #466B86;
  --el-tag-text-color: var(--solar-text-strong, #FFFFFF);
}

:deep(.tag-processing) {
  --el-tag-bg-color: #E6A23C;
  --el-tag-text-color: var(--solar-on-primary, #001A33);
}

:deep(.tag-finished) {
  --el-tag-bg-color: #00A40C;
  --el-tag-text-color: var(--solar-text-strong, #FFFFFF);
}

:deep(.dialog-select) {
  --el-input-bg-color: var(--solar-on-primary, #001A33) !important;
  --el-input-border-color: var(--solar-border, #003567) !important;
  --el-input-text-color: var(--solar-text, #87CEFA) !important;
  --el-input-placeholder-color: var(--solar-muted, #6699CC) !important;
  --el-select-bg-color: var(--solar-on-primary, #001A33) !important;
  --el-select-border-color: var(--solar-border, #003567) !important;
  --el-select-text-color: var(--solar-text, #87CEFA) !important;
  --el-select-placeholder-color: var(--solar-muted, #6699CC) !important;
  width: 100%;
}

:deep(.dialog-select .el-input__wrapper),
:deep(.dialog-select .el-select__wrapper) {
  background-color: var(--solar-page, #001A33) !important;
  border-color: var(--solar-border, #003567) !important;
  box-shadow: none !important;
}

:deep(.dialog-select .el-input__inner),
:deep(.dialog-select .el-select__placeholder),
:deep(.dialog-select .el-select__label) {
  color: var(--solar-text, #87CEFA) !important;
}

/* 弹窗整体样式 */
:deep(.warn-process-dialog) {
  --el-dialog-bg-color: var(--solar-on-primary, #002B4D) !important;
  --el-dialog-header-text-color: var(--solar-text, #87CEFA) !important;
  --el-dialog-border-color: var(--solar-border, #003567) !important;
}

:deep(.warn-process-dialog .el-dialog__header) {
  background-color: var(--solar-page, #001A33) !important;
  border-bottom: 1px solid var(--solar-border, #003567) !important;
  padding: 16px 20px !important;
}

:deep(.warn-process-dialog .el-dialog__title) {
  color: var(--solar-text, #87CEFA) !important;
  font-size: 16px !important;
  font-weight: 500;
}

:deep(.warn-process-dialog .el-dialog__close) {
  color: var(--solar-text, #87CEFA) !important;
}

:deep(.warn-process-dialog .el-dialog__close:hover) {
  color: var(--solar-primary, #00CCFF) !important;
}

:deep(.warn-process-dialog .el-dialog__body) {
  background-color: var(--solar-surface, #002B4D) !important;
  color: var(--solar-text, #87CEFA);
  padding: 20px !important;
}

:deep(.warn-process-dialog .el-dialog__footer) {
  background-color: var(--solar-surface, #002B4D) !important;
  border-top: 1px solid var(--solar-border, #003567);
  padding: 15px 20px;
}

:deep(.blue-form) {
  background-color: var(--solar-surface, #002B4D) !important;
  width: 100%;
}

:deep(.el-form-item__label) {
  color: var(--solar-text, #87CEFA) !important;
}

:deep(.el-form-item__required) {
  color: var(--solar-primary, #00CCFF) !important;
}

:deep(.dialog-textarea .el-textarea__inner) {
  background-color: var(--solar-page, #001A33) !important;
  color: var(--solar-text, #87CEFA) !important;
  border: 1px solid var(--solar-border, #003567) !important;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn {
  --el-button-bg-color: var(--solar-on-primary, #003567);
  --el-button-border-color: var(--solar-border, #003567);
  --el-button-text-color: var(--solar-text, #87CEFA);
  --el-button-hover-bg-color: var(--solar-on-primary, #00407F);
}

.save-btn {
  --el-button-bg-color: var(--solar-primary, #0099FF);
  --el-button-hover-bg-color: var(--solar-primary, #0066CC);
  --el-button-text-color: var(--solar-on-primary, #002B4D);
  --el-button-border-color: var(--solar-border-strong, #0099FF);
}

/* 滚动条样式 */
:deep(::-webkit-scrollbar) {
  width: 6px;
  height: 6px;
  background-color: var(--solar-page, #001A33);
}

:deep(::-webkit-scrollbar-thumb) {
  background-color: var(--solar-primary, #0099FF);
  border-radius: 3px;
}

:deep(::-webkit-scrollbar-track) {
  background-color: var(--solar-surface, #002B4D);
  border-radius: 3px;
}

@media (max-width: 760px) {
  .warn-manage-page .search-item,
  .warn-manage-page .warn-device-filter,
  .warn-manage-page .warn-status-filter {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
  }
}

</style>
